import api from './api-caller';
const baseEndpoint = '/transactions'

export default {
  getDataAssetTransactions: (id) => {
    const endpoint = `${baseEndpoint}/${id}`
    return api(endpoint, 'GET')
  }
}
